import { recordAnalyticsEvent } from "../../analytics";
import { Header, Section } from "../../components/layout";
import { useFlag } from "../../config/featureFlags";
import ClientList from "../portfolio/clientList";
import * as Styled from "./styles.css";
import { Link } from "@safetyculture/sc-web-ui";
import { urls } from "../../config/appConfig";

const Policies = () => {
  const handleQuoteClick = () => {
    recordAnalyticsEvent("action", "Create Quote", {
      path: urls.brokerLoginLink,
    });
  };

  return (
    <Styled.Grid $fullHeight={true}>
      <Header
        actions={
          useFlag("portal.quotebutton") && (
            <Link
              type="button"
              href={urls.brokerLoginLink}
              target="_blank"
              onClick={handleQuoteClick}
              style={{ color: "white" }} // temporary // TODO: Upgrade sc-web-ui to remove this line
            >
              Create quote
            </Link>
          )
        }
        title="Policies"
        titleIcon="file"
        titleIconPosition="start"
        type="article"
      />

      <Section>
        <ClientList />
      </Section>
    </Styled.Grid>
  );
};

export default Policies;
